/**
 * Created by fd on 2021-09-22 (13:39).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/intro-sell.html";

require("Styles/components/popup/intro-sell.scss");

class IntroSellView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.event = options.event;
    }
}

module.exports = IntroSellView;



// WEBPACK FOOTER //
// ./app/js/components/popup/intro-sell.js